import { useLocation, useSearchParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useMediaQuery, useTheme } from '@mui/material'

import {
  MainContainer,
  EditAccount,
  AccountMobileNavigation,
  AccountTabLinks,
  HelperWrapper,
  Loader,
} from 'src/components'
import { ETranslationNs } from 'src/types'
import { Suspense } from 'react'

const EditAccountScreen = () => {
  const [t] = useTranslation([ETranslationNs.Common, ETranslationNs.Navbar])
  const [searchParams] = useSearchParams()
  const location = useLocation()
  const currentTab = searchParams.get('tab')
  const theme = useTheme()
  const isLaptop = useMediaQuery(theme.breakpoints.down('laptop'))

  const headerMobileTitle =
    currentTab === AccountTabLinks.profile
      ? t('account-add-header-title.v')
      : currentTab === AccountTabLinks.billing
      ? t('edit-account-title-1.v')
      : currentTab === AccountTabLinks.users
      ? t('account-users-header-title.v')
      : currentTab === AccountTabLinks.settings
      ? t('account-settings-header-title.v')
      : t('edit-account-title-2.v')

  return (
    <Suspense fallback={<Loader />}>
      <MainContainer
        headerTitle={isLaptop ? headerMobileTitle : <HelperWrapper t="edit-account-title-2" />}
        navigateBack={!!currentTab}
        navigateBackRoute={location.pathname}
        withScanBtn
      >
        {isLaptop && !currentTab ? <AccountMobileNavigation /> : <EditAccount />}
      </MainContainer>
    </Suspense>
  )
}

export default EditAccountScreen
